exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n  color: #676363; }\n\nh4 {\n  color: #676363;\n  font-size: 1.25em;\n  margin: 0 0.5em 0 0.5em; }\n\n.center {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%); }\n\n.img-center {\n  vertical-align: middle; }\n\n.pull-down {\n  margin-top: 1.0em;\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Dan/Documents/PoC/angular-giaa/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = 3